import styled from "styled-components";

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 590px;
    background: #fff;
    border-radius: 35px;
    padding: 60px 40px;
    /* padding: calc(25px + (25) * ((100vw - 320px) / (1200 - 320))); */
    /* width: 80%; */
    @media (max-width: 1240px) {
        padding: 30px 20px;
    }
`;

export const ReviewHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    flex-direction: row;
`;

export const ReviewHeaderDate = styled.div`
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    @media (max-width: 1240px) {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
    }
`;

export const ReviewText = styled.div`
    font-family: "TT Commons Pro", sans-serif;
    font-weight: 300;
    font-style: normal;
    margin-bottom: 35px;
    font-weight: 400;
    font-size: 28px;
    line-height: 35px;
    max-height: 250px;
    @media (max-width: 1240px) {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
    }
`;

export const ReviewFooter = styled.div`
    display: flex;
    height: 100%;
    align-items: end;
`;

export const ReviewLogo = styled.img`
    height: 50px;
`;
